import fetchHotItems from "../../services/products/HotProductsApi.js"
import React, { useState, useEffect, useCallback } from "react";
import Nav from "react-bootstrap/Nav";
import "./Billing.css";
import Items from "../../components/items/Items.jsx";
import Drawer from "../../components/drawer/Drawer.jsx";
import SearchBar from "../../components/searchbar/SearchBar.js";
import { X, TriangleAlert } from "lucide-react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Invoice from "../../components/invoice/Invoice.jsx";
import { useRef } from "react";
import printJS from "print-js";
import style from "./Billing.module.scss";
import Kot from "../../components/kot/Kot.jsx";
import { toast } from 'react-toastify';
import fetchProducts from "../../services/products/fetchProducts.js"
import ITEM_TOASTS from "../../utils/constants/toastMesages/itemToastMessage.js";
import { STORAGE_KEYS } from "../../utils/constants/storageKeys.js";
import printInvoices from "../../hooks/printInvoices";
/**
 * Main component for the Billing page.
 * Renders all the other components of other functionalities like SearchBar,Items and Items Drawer
 * @component
 * @returns {JSX.Element} - billing component
 */
function Billing() {
  // State for hot items (for Hot tab)
  const [hotItems, setHotItems] = useState([]);
  // For tracking if generate invoice button is been clicked or not
  const [invoiceGenerated, setInvoiceGenerated] = useState(false);
  // Initial state: show first 6 items
  const [visibleCount, setVisibleCount] = useState(6);
  const loadMoreRef = useRef(null);
  //Usestate hook to render/populate category tabs.
  const [categories, setCategories] = useState([]);
  //Soft Drinks category will be default when component renders.
  const [selectedCategory, setSelectedCategory] = useState("All");
  //Use state hook to set search text in the serach component.
  const [searchText, setSearchText] = useState("");
  //Use state hook to populate items cards in the ui.
  const [items, setItems] = useState([]);
  //It is an object that stores the quantity of each item, with the item ID as the key and its quantity as the value.
  const [itemQuantity, setItemQuantity] = useState({});
  //This is used to track the order of the added items
  const [addedItemIds, setAddedItemIds] = useState([]);
  //Use State to show or close the invoice modal.
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  //To track if kot already been generated or not 
  const [kotGenerated, setKotGenerated] = useState(false)
  // For tracking if order been placed or not 
  const [addedOrder, setAddedOrder] = useState(false);

  const [showTopBar, setShowTopBar] = useState(true);

  const scrollRef = useRef(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    if (!isMobile) return;

    const el = scrollRef.current;
    if (!el) return;

    let lastScrollY = 0;

    const handleScroll = () => {
      const currentScrollY = el.scrollTop;

      if (Math.abs(currentScrollY - lastScrollY) < 10) return;

      if (currentScrollY < lastScrollY) {
        setShowTopBar(true);
      } else {
        setShowTopBar(false);
      }

      lastScrollY = currentScrollY;
    };

    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, [isMobile]);

  // Decide how to handle Print Invoice click based on device type
  const handlePrintInvoiceClick = useCallback(async (invoiceType) => {
    if (!show) setShow(true);
    await new Promise(resolve => setTimeout(resolve, 250));
    return await printInvoices(invoiceType);
  }, [show]);
  //For handling customer name and phone number
  const [custDetails, setCustDetails] = useState({
    name: "",
    mobileNumber: "",
    paymentType: "Cash",
    orderType: "take-away",
    tableNumber: "",
    items: []
  });

  //States for saving response data received after placing order 
  const [invoiceData, setInvoiceData] = useState(null);

  //This will display the toast again after page reload
  useEffect(() => {
    const storedToasts = JSON.parse(localStorage.getItem(STORAGE_KEYS.LOW_STOCKMESSAGE) || "[]");
    storedToasts.forEach(msg => toast.warning(msg));
    localStorage.removeItem(STORAGE_KEYS.LOW_STOCKMESSAGE);
  }, []);

  // Fetch hot items when the component mounts
  useEffect(() => {
    const getHotItems = async () => {
      try {
        const res = await fetchHotItems();
        setHotItems(res.data || []);
      } catch (err) {
        console.error("Failed to fetch hot items:", err);
      }
    };
    getHotItems();
  }, []);
  //UseEffect hook after your data fetching effect for lazy loading/infinite loading effect
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisibleCount((prev) => prev + 6); // Load 6 more items
        }
      },
      { threshold: 1.0 }
    );

    const loadMoreElement = loadMoreRef.current;
    if (loadMoreElement) {
      observer.observe(loadMoreElement);
    }

    return () => {
      if (loadMoreElement) {
        observer.unobserve(loadMoreElement);
      }
    };
  }, []);

  //Useref for invoice element
  const printInvoiceRef = useRef();

  //Function to print the kot
  const handleKotPrint = () => {
    // Print the element by its id or pass the raw DOM node:
    const kotContent = document.getElementById("kot-print-section");

    if (kotContent) {
      const customStyle = `
      <style>
      #kot-print-section{
      }
        #kot-print-section {
        font-size: 40px !important;
        line-height: 1.4 !important;
        font-family: Arial, sans-serif !important;
      }

        #kot-print-section .d-flex {
          display: flex !important;
        }

        #kot-print-section .justify-content-center {
          justify-content: center !important;
        }

        #kot-print-section .justify-content-between {
          justify-content: space-between !important;
        }

        #kot-print-section .pb-4 {
          padding-bottom: 1.5rem !important;
        }

        #kot-print-section .pt-3 {
          padding-top: 1rem !important;
        }

        #kot-print-section .gap-2 {
          gap: 0.5rem !important;
        }

        #kot-print-section .fw-bold {
          font-weight: 700 !important;
        }

        #kot-print-section img {
          height: 50px !important;
        }

        #kot-print-section h6 {
          margin: 0 !important;
          font-weight: normal !important;
          font-size: 35px !important;
        }

        #kot-print-section table {
          width: 100% !important;
          border-collapse: collapse !important;
          margin: 0 !important;
        }

        #kot-print-section table th,
        #kot-print-section table td {
          padding: 10px !important;
          font-size: 40px !important;
          border: none !important;
        }

        #kot-print-section table th {
          text-align: left !important;
          font-weight: 700 !important;
          padding:10px !important;
        }
          #kot-print-section table th:last-child {
          text-align: right !important;
        }


        #kot-print-section table th:first-child,
        #kot-print-section table td:first-child {
          text-align: left !important;
        }

        #kot-print-section p {
          margin: 0 !important;
          font-size: 40px !important;
        }

        #kot-print-section p.fw-bold {
          font-weight: 700 !important;
          padding:10px !important;
        }

        #kot-print-section p[style] {
          /* Override inline font-size for totals */
          font-size: 50px !important;
        }

        #kot-print-section hr {
          border-top: 1px solid black !important;
          margin: 0.5rem 0 !important;
        }

        #kot-print-section .thank-you-text {
          font-style: italic !important;
          font-size: 40px !important;
        }

        #kot-print-section p[style*="font-size: 12px"] {
          font-size: 25px !important;
          margin-top: 0.5rem !important;
        }
        #kot-print-section .builtBy p{
        font-size: 30px !important;
        }
        #kot-print-section .thankYouCont{
        display: flex !important;
        flex-direction: column !important;
        padding-top: 40px !important;
        }
        #kot-print-section hr{
          font-weight: 800px !important;
        }

      </style>
    `;

      // Print.js - using raw HTML content with the injected style
      printJS({
        printable: kotContent.outerHTML + customStyle,
        type: 'raw-html',
        style: '', // Optional: you can inject more styles here
        scanStyles: false, // Disable scanning of existing page styles

      });
    }
    setKotGenerated(true);
  };

  const handleInvoicePrint = () => {
    // Print the element by its id or pass the raw DOM node:
    const invoiceContent = document.getElementById("invoice");
    if (invoiceContent) {
      const customStyle = `
            <style>
            #invoice {
              font-size: 40px !important;
              padding: 20px;
            }
            #invoice .image {
              display: flex !important;
              justify-content: center !important;
            }
            #invoice .orderlytext {
              display: flex !important;
              flex-direction: column !important; /* you had 'row' but your original was column */
              justify-content: center !important;
              text-align: center;
              font-size:40px !important;
              padding-top:30px !important;
            }
              #invoice img{
              height:200px !important;
              width:250px !important;
              }
            #invoice .less-width {
              /* Add styles if needed */
              font-size: 50px !important;
            }
            #invoice table th, #invoice table td {
              font-size: 40px !important;
              padding-top: 30px !important;
              
            }
            #invoice .fw-bold {
              font-size: 40px !important;
            }
            #invoice .thank-you {
              font-size: 50px !important;
              font-weight: bold;
              text-align: center;
              margin-top: 20px;
            }
              #invoice .left-align{
              display: flex !important;
              flex-direction: column !important; /* you had 'row' but your original was column */
              justify-content: center !important;
              text-align: left;
              font-size:40px !important;
              padding-top:50px !important;
              }
              #invoice .total-items{
              padding-top:40px !important;
              display: flex !important;
              flex-direction: column !important;
              }
              #invoice .fw-bold{
              font-weight: bold !important;
              }
              #invoice .justify-content-between{
              justify-content: space-between !important;
              }
              #invoice .total-price span{
              // text-align:center !important;
              font-size:90px !important;
              }
              #invoice .total-price{
                text-align:center !important;
                padding-top: 30px !important;
                padding-bottom: 30px !important;
              }
              #invoice .justify-content-between{
              display:flex !important;
              justify-content: space-between !important;
              }
              #invoice .justify-content-center{
              display:flex !important;
              justify-content:center !important;
              // padding-bottom:30px !important;
              }
          </style>
    `
      // KOT already generated; just print the invoice
      printJS({
        printable: invoiceContent.outerHTML + customStyle,
        type: "raw-html",
        scanStyles: false
      });
    }
  };


  // Useeffect method for fetching data from the json server.
  useEffect(() => {
    //This fetch method fetches data from the backend and saves the data in the frontend ui.
    const fetchData = async () => {
      try {
        const data = await fetchProducts();
        setItems(data.data)
        //Removes redundent category and sets unique categories on the tabs section.
        const uniqueCategories = [
          ...new Set(data.data.map((item) => item.category?.name || item.category)),
        ];
        setCategories(uniqueCategories)
      } catch (error) {
        console.error(ITEM_TOASTS.ITEMS_NOT_FETCHED);
      }
    };

    fetchData();
  }, []);

  /**
   * Updates the quantity of an individual item.
   *
   * @param {string | number} id - unique identifier of the item.
   * @param {number} change - amount to change the quantity by +1 or -1.
   */
  const updateQuantity = (id, change) => {
    setItemQuantity((prev) => {
      const newQuantity = Math.max(0, (prev[id] || 0) + change);

      setAddedItemIds((prevIds) => {
        // If item is being added and not already tracked, add it
        if (newQuantity > 0 && !prevIds.includes(id)) {
          return [...prevIds, id];
        }
        // If item is being removed (quantity 0), remove it from list
        if (newQuantity === 0 && prevIds.includes(id)) {
          return prevIds.filter((itemId) => itemId !== id);
        }
        return prevIds;
      });

      return {
        ...prev,
        [id]: newQuantity,
      };
    });
  };

  // Filters items based on category and search input.
  const filteredItems = items.filter((item) => {
    const search = searchText.toLowerCase();
    const name = item.name.toLowerCase();
    // Only match if a word in the name starts with the search text
    return (
      (item.category?.name || item.category) === selectedCategory &&
      name.split(" ").some((word) => word.startsWith(search))
    );
  });

  // Resets item quantities by setting 'itemQuantity' to an empty object, also clear the drawer also.
  const clear = () => {
    const resetQuantities = {};
    items.forEach((item) => {
      //Resets all the item quantity to 0 unless its leading to NaN error
      resetQuantities[item.id] = 0;
    });
    setItemQuantity(resetQuantities);
    setAddedItemIds([]);
  };

  //Handles printing of the jsx component
  const allFiltered = items.filter((item) => {
    const search = searchText.toLowerCase();
    const name = item.name.toLowerCase();
    // Only match if a word in the name starts with the search text
    return name.split(" ").some((word) => word.startsWith(search));
  });

  // This useEffect handles printing the final invoice when the modal is open
  useEffect(() => {
    const handleEnterKey = async (e) => {
      // If the invoice modal is open AND the invoice hasn't been generated yet...
      if (e.key === 'Enter' && show && !invoiceGenerated) {
        e.preventDefault();
        const success = await handlePrintInvoiceClick('invoice');
        if (success) setInvoiceGenerated(true);
      }
      else if (e.key === 'Enter' && show && invoiceGenerated) {
        e.preventDefault();
        window.location.reload();
      }
    };

    window.addEventListener('keydown', handleEnterKey);
    return () => {
      window.removeEventListener('keydown', handleEnterKey);
    };
  }, [show, invoiceGenerated, handlePrintInvoiceClick]);

  return (
    <div className={`${style.MainCont}`}>
      {/* Navigation Tabs */}
      <div
        className={`top-bar ${showTopBar ? "show" : "hide"}`}
      >
        <div className="p-3 d-flex tabs-container">
          <Nav
            variant="tabs"
            style={{ gap: "5px" }}
            activeKey={selectedCategory}
            onSelect={(key) => setSelectedCategory(key)}
          >
            <Nav.Item>
              <Nav.Link
                style={{
                  backgroundColor:
                    selectedCategory === "All" ? "#3399ff" : "#f2f2f2",
                  color: selectedCategory === "All" ? "white" : "black",
                  WebkitTextFillColor:
                    selectedCategory === "All" ? "white" : "black",
                }}
                eventKey={"All"}
                className={style.badgesStyle}
              >
                All
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                style={{
                  backgroundColor:
                    selectedCategory === "Hot" ? "#3399ff" : "#f2f2f2",
                  color: selectedCategory === "Hot" ? "white" : "black",
                  WebkitTextFillColor:
                    selectedCategory === "Hot" ? "white" : "black",
                }}
                eventKey={"Hot"}
                className={style.badgesStyle}
              >
                Hot 🔥
              </Nav.Link>
            </Nav.Item>
            {/* Sets Item category names to the category tabs.  */}
            {categories.map((category) => (
              <Nav.Item key={category}>
                <Nav.Link
                  style={{
                    backgroundColor:
                      selectedCategory === category ? "#3399ff" : "#f2f2f2",
                    color: selectedCategory === category ? "white" : "black",
                    WebkitTextFillColor:
                      selectedCategory === category ? "white" : "black",
                  }}
                  eventKey={category}
                  className={style.badgesStyle}
                >
                  {category}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>
      </div>
      <div style={{ position: 'sticky', top: '60px', zIndex: 99, backgroundColor: 'white' }}>
        {/* State props for searching functionality*/}
        <SearchBar searchText={searchText} setSearchText={setSearchText} />
      </div>
      {/* Main Content Section */}
      <div className="d-flex flex-column item-container">
        <div ref={scrollRef} className={style.firstSection} style={{ overflowY: "auto" }}>
          {/* If all category is been selected all data will be shown */}
          {selectedCategory === "Hot" &&
            hotItems.map((item) => (
              <Items
                key={item._id}
                item={item}
                quantity={itemQuantity[item._id]}
                updateQuantity={updateQuantity}
                addedOrder={addedOrder}
                setAddedOrder={setAddedOrder}
                selectedCategory={selectedCategory}
              />
            ))}
          {
            // On selecting all category tabs, this will be shown
            selectedCategory === "All" &&
            allFiltered.slice(0, visibleCount).map((item) => (
              <Items
                key={item._id}
                item={item}
                addedOrder={addedOrder}
                setAddedOrder={setAddedOrder}
                // Props to update quantity of every individual item.
                quantity={itemQuantity[item._id]}
                //Prop method to update quantity of every individual item.
                updateQuantity={updateQuantity}
              />
            ))
          }
          {/* Items will be shown according to filetedred items */}
          {filteredItems.length > 0
            ? filteredItems.map((item) => (
              <Items
                key={item._id}
                item={item}
                addedOrder={addedOrder}
                setAddedOrder={setAddedOrder}
                // Props to update quantity of every individual item.
                quantity={itemQuantity[item._id]}
                //Prop method to update quantity of every individual item.
                updateQuantity={updateQuantity}
                setItemQuantity={setItemQuantity[item.id]}
              />
            ))
            : selectedCategory !== "All" &&
            selectedCategory !== "Hot" && (
              /**
          If theres no related data after filteration, this div will render in ui (conditional rendering).
           */
              <div className="text-center m-auto p-4 gap-4 justify-content-center align-items-center d-flex flex-column text-muted">
                <X size={100} color="gray" style={{ opacity: "40%" }} />
                <div
                  className={`${style.noItem}`}
                >
                  No items found
                </div>
              </div>
            )}
        </div>
        {/* Invoice modal to popup when the  */}
        <Modal centered show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ height: "70vh", overflowX: "auto" }}>
            <div ref={printInvoiceRef} className="invoice-div">
              {
                //if kotnot been generated print kot component will also be shown
                !kotGenerated && <div className="pb-4" >
                  <div id="kot-print-section">
                    <p style={{ color: "orange" }} className="d-flex align-items-center">< TriangleAlert size={18} />
                      You haven't printed your KOT yet!</p>
                    <Kot
                      items={items}
                      addedItemIds={addedItemIds}
                      itemQuantities={itemQuantity}
                      custDetails={custDetails}
                      invoiceData={invoiceData}
                    />
                  </div>
                  <div className="d-flex w-100 justify-content-end"><Button variant="danger" onClick={async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const success = await printInvoices('kot-print-section');
                    if (success) setKotGenerated(true);
                  }}>
                    Print Kot</Button></div>
                  <hr />
                </div>
              }
              <div id="invoice">
                <Invoice
                  items={items}
                  addedItemIds={addedItemIds}
                  itemQuantities={itemQuantity}
                  custDetails={custDetails}
                  invoiceData={invoiceData}
                />
              </div>
            </div>
          </Modal.Body>
          <hr />
          <div className="p-3">
            <div>
              {!invoiceGenerated ? (
                <div className="d-flex flex-column gap-3">
                  <Button
                    onClick={async (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      const success = await handlePrintInvoiceClick('invoice');
                      if (success) setInvoiceGenerated(true);
                    }}
                  >
                    Print
                  </Button>
                </div>
              ) : (
                <div className="d-flex flex-column gap-3">
                  <Button onClick={() => window.location.reload()}>Done</Button>
                </div>
              )}
            </div>

          </div>
        </Modal>
        {/* Drawer component */}
        <div className={`${style.Drawer} drawer1`}>
          <Drawer
            items={items}
            //Props that goes to the drawer component.
            itemQuantities={itemQuantity}
            //Uses the clear methods to clear/reset the drawer and items quantity.
            clear={clear}
            //Handles modal show feature for the button
            handleShow={handleShow}
            addedItemIds={addedItemIds}
            updateQuantity={updateQuantity}
            kotGenerated={kotGenerated}
            setKotGenerated={setKotGenerated}
            handleKotPrint={handleKotPrint}
            setCustDetails={setCustDetails}
            custDetails={custDetails}
            setInvoiceData={setInvoiceData}
            invoiceData={invoiceData}
            invoiceShow={show}
            addedOrder={addedOrder}
            setAddedOrder={setAddedOrder}
            handleInvoicePrint={handleInvoicePrint}
            onPrintInvoiceClick={handlePrintInvoiceClick}
            setInvoiceGenerated={setInvoiceGenerated}
          />
        </div>
        <div ref={loadMoreRef} style={{ minHeight: '1px', minWidth: "1px" }}></div>
      </div>

    </div>
  );
}

export default Billing;
